import { Typography } from "@mui/material";
import styles from "./index.module.css";
import { CorePaper, CoreSkeletonWrapper } from "../../core";
import { ConditionalWrapper } from "../../wrapper";
import { useMobileLayout } from "../../hooks";

type StepDescriptionProps = {
	children: React.ReactNode;
	loading?: boolean;
};

export default function StepDescription({ children, loading }: StepDescriptionProps) {
	return (
		<CoreSkeletonWrapper loading={loading}>
			<Typography className={styles.stepDescription}>{children}</Typography>
		</CoreSkeletonWrapper>
	);
}

/**Handles Mobile Layout */
export function StepWrapper({ children }: { children: React.ReactNode }) {
	const isMobileLayout = useMobileLayout();
	return (
		<ConditionalWrapper
			condition={isMobileLayout}
			whenTrue={(children) => (
				<CorePaper component={"section"} className={styles.stepPaper}>
					{children}
				</CorePaper>
			)}
		>
			{children}
		</ConditionalWrapper>
	);
}
